export default __webpack_public_path__ + "static/media/bishop2.74710ff3.png";